import TableHeaderBox from './TableHeaderBox';
export default TableHeaderBox;


// WEBPACK FOOTER //
// ./src/components/TableHeaderBox/index.js